<template>
  <v-tabs vertical :loading="loading">
    <v-tab v-for="implant in implants" :key="`implant-${implant.type_id}`">
      <img :src="implant.image_url" />
    </v-tab>

    <v-tab-item v-for="implant in implants" :key="`tab-implant-${implant.type_id}`">
      <v-card flat>
        <v-card-title>{{ implant.name }}</v-card-title>
        <v-card-text>
          <p
            v-for="(para, index) in implant.description.split('\r\n')"
            :key="`implant-${implant.type_id}-${index}`"
            v-html="para"
          /> 
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CharacterImplants",
  computed: {
    ...mapState({
      implants: state => {
        return state.character_implants
          .map(type_id => {
            const type = state.types.find(x => x.type_id == type_id);
            if (!type) return;
            type.image_url = `https://images.evetech.net/types/${type_id}/icon?size=32`;
            return type;
          })
          .filter(Boolean);
      },
    })
  },
  methods: {
    loadImplants() {
      this.loading = true;
      this.$store
        .dispatch("loadCharacterImplants")
        .then(() => (this.loading = false));
    }
  },
  created() {
    this.loadImplants();
  }
}
</script>
